import { render, staticRenderFns } from "./review-insurance.vue?vue&type=template&id=533e1f54"
import script from "./review-insurance.vue?vue&type=script&lang=js"
export * from "./review-insurance.vue?vue&type=script&lang=js"
import style0 from "./review-insurance.vue?vue&type=style&index=0&id=533e1f54&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports